import React__default from 'react';
import { ListEditorCore } from '../shared/components/ListEditor.mjs';
export { ADD_NEW_BUTTON_TEXT } from '../shared/components/ListEditor.mjs';
import { Button } from './Button.mjs';
import { EmbeddedTable } from './EmbeddedTable.mjs';
import { Modal } from './Modal.mjs';
import { Typography } from './Typography.mjs';

const ListEditor = (props)=>{
    return /*#__PURE__*/ React__default.createElement(ListEditorCore, {
        ...props,
        ButtonComponent: Button,
        EmbeddedTableComponent: EmbeddedTable,
        ModalComponent: Modal,
        TypographyComponent: Typography
    });
};

export { ListEditor };
//# sourceMappingURL=ListEditor.mjs.map
